import { Modal } from '@/components/ui/modal';
import { SaltConfigForm } from '@/features/devices/components/salt-quick-config-banner';
import type { Device } from '@/types/api';

interface Props {
  device: Device | null;
  isOpen: boolean;
  onClose: () => void;
  onSaved: () => void;
}

// In-flow pulse-config modal opened from a SALT tile's "Configure Pulses"
// CTA in Setup Mode. Reuses the same form (and same save endpoints) as
// the inline SaltQuickConfigBanner on Device Details so the installer
// doesn't have to bounce between pages to calibrate after pairing.
export function SetupModePulseConfigModal({ device, isOpen, onClose, onSaved }: Props) {
  return (
    <Modal
      isOpen={isOpen && device !== null}
      onClose={onClose}
      title="Configure Pulses"
      description={
        device
          ? `Set the multiplier and unit of measure for ${device.serialNumber}.`
          : undefined
      }
      size="md"
    >
      {device && (
        <SaltConfigForm
          device={device}
          onSaved={() => {
            onSaved();
            onClose();
          }}
        />
      )}
    </Modal>
  );
}
